export const isMobile = (): boolean => {
    return window.innerWidth <= 768;
};

// New function to check if device is mobile or tablet
export const isMobileOrTablet = (): boolean => {
    return window.innerWidth <= 1024; // Common breakpoint for tablets is 1024px
};
